var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTravelagency11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2514_43021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.215 27.0488C12.1176 27.9834 10.443 29.7494 9.65891 31.9653L14.8235 40.4358L16.047 41.377L17.647 40.4358L18.5882 33.777L17.647 28.4358L14.215 27.0488Z",
    fill: "#75E1F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6364 28.7994L23.6363 28.7993C22.8878 28.0509 22.024 27.4597 21.0851 27.0425L17.6471 28.4358V40.4358L21.6628 41.377L26.1177 40.4358V34.7887C26.1177 32.5265 25.2365 30.3995 23.6364 28.7994Z",
    fill: "#3BA9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4011 27.2881L40.0784 25.9102L37.0779 27.2824C35.5758 28.2972 34.5883 30.0158 34.5883 31.965V34.7886H31.7647L30.8235 37.863L31.7647 40.4356L34.5883 48.9062H45.8824V31.965C45.8824 30.0194 44.8984 28.3037 43.4011 27.2881Z",
    fill: "#00347B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8235 43.2591H34.5882L33.647 41.8473L34.5882 40.4355H38.8235V43.2591Z",
    fill: "#001737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9412 0.90625C24.2705 0.90625 20.4706 4.70616 20.4706 9.37684C20.4706 10.5 20.6908 11.5725 21.0896 12.5543L36.8154 12.4988C37.2 11.5321 37.4118 10.4789 37.4118 9.37684C37.4118 4.70616 33.6119 0.90625 28.9412 0.90625Z",
    fill: "#75E1F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9412 17.8474C32.5099 17.8474 35.5701 15.6289 36.8154 12.4988L35.9339 11.7987L30.2205 7.5127L28.3564 9.37679H25.6902L22.0311 11.8162L21.0896 12.5542C22.349 15.6549 25.3937 17.8474 28.9412 17.8474Z",
    fill: "#50C778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2353 28.4356C42.9642 28.4356 45.1765 26.2233 45.1765 23.4944C45.1765 20.7655 42.9642 18.5532 40.2353 18.5532C37.5064 18.5532 35.2941 20.7655 35.2941 23.4944C35.2941 26.2233 37.5064 28.4356 40.2353 28.4356Z",
    fill: "#FCB0A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8235 40.4354L7.95294 41.3766L2.11765 40.4354V31.9648H14.8235V40.4354Z",
    fill: "#00347B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9412 40.4356L30.3529 41.3768L31.7647 40.4356V34.7886H28.9412V40.4356Z",
    fill: "#FCB0A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7059 23.4944C12.7059 26.2232 14.918 28.4356 17.647 28.4356L18.5882 23.4944L17.647 18.5532C14.918 18.5532 12.7059 20.7654 12.7059 23.4944Z",
    fill: "#FDD0BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6471 18.5532V28.4356C20.3761 28.4356 22.5882 26.2232 22.5882 23.4944C22.5882 20.7654 20.3761 18.5532 17.6471 18.5532Z",
    fill: "#FCB0A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.11765 40.4355V48.9061H17.6471L18.5882 44.4355L17.6471 40.4355H2.11765Z",
    fill: "#FFB54C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6471 40.4355H34.5882V48.9061H17.6471V40.4355Z",
    fill: "#FF8756"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2514_43021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.90625)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelagency11);
export default __webpack_public_path__ + "static/media/travelagency-1-1.da43515500c51cba33608879a1d67d32.svg";
export { ForwardRef as ReactComponent };